import { Button, message, Popover, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { bidEvaluationsActions } from "../../../../config/actions/procument/bidEvaluations/bidEvaluations.actions";
import routes from "../../../../config/routes/routes";
import generatePDF from "../../../../config/services/generatePdf";
import tableButtonActions from "../../../shared/Tables/TableButtonActions";
import TableTitle from "../../../shared/Tables/TableTitle";

const BidEvaluationsTable = ({
  handleDelete,
  handleRefreshTable,
  handleExportRecords,
  handleOpenAddModal,
  handleOpenEditModal,
  handleViewDetails,
}) => {
  const [deleteId, setDeleteId] = useState("");
  const [filterTable, setfilterTable] = useState(null);
  const {
    bidEvaluations: data,
    bidEvaluationsLoading: loading,
    bidEvaluationsSuccess: success,
    bidEvaluationsError: error,
    deleteBidEvaluationsLoading: deleteLoading,
    deleteBidEvaluationsSuccess: deleteSuccess,
    deleteBidEvaluationsError: deleteError,
    deleteBidEvaluationsMessage: deleteMessage,
  } = useSelector((state) => state.bidEvaluationState);
  const {
    success: logDetailsSuccess,
    error: logDetailsError,
    records,
  } = useSelector((state) => state.logDetailsState.addLogDetails);
  const dispatch = useDispatch();
  const history = useHistory();
  const columns = [
    {
      title: "Bid Evaluation Form No.",
      key: "rfqno",
      render: (text) => (
        <div>
          <span className="d-md-none">Bid Evaluation Form No.:</span> {text.id}{" "}
          <br />
          <div className="d-md-none">
            RFQ No.: {text.rfqno} <br />
            <Popover
              className=""
              trigger="click"
              placement="bottom"
              content={() =>
                tableButtonActions(text, {
                  viewDetails,
                  updateRecord,
                  confirmDelete,
                  deleteRecord,
                  deleteLoading,
                  deleteId,
                })
              }
            >
              Actions: <Button type="link">Actions</Button>
            </Popover>
          </div>
        </div>
      ),
    },
    {
      title: "RFQ No.",
      key: "rfqno",
      dataIndex: "rfqno",
      responsive: ["md"],
    },
    {
      title: "Action",
      key: "operation",
      responsive: ["md"],
      render: (text) => (
        <Popover
          trigger="click"
          placement="bottom"
          content={() =>
            tableButtonActions(text, {
              viewDetails,
              updateRecord,
              confirmDelete,
              deleteRecord,
              deleteLoading,
              deleteId,
            })
          }
        >
          <Button>Actions</Button>
        </Popover>
      ),
    },
  ];
  /* Functions */
  const deleteRecord = (e) => setDeleteId(e.target.id);
  const confirmDelete = () => {
    const bidEvaluationsArray = data.filter((e) => e.id !== deleteId);
    handleDelete(deleteId, bidEvaluationsArray);
  };
  const refreshTable = () => {
    handleRefreshTable();
    if (!success && error) message.error(error);
  };
  const updateRecord = (e) => {
    const bidEvaluationsArray = data.filter((el) => el.id === e.target.id);
    dispatch(
      bidEvaluationsActions.editBidEvaluationsData(bidEvaluationsArray[0])
    );
    handleOpenEditModal(true);
  };
  const viewDetails = (e) =>
    history.push(`${routes.procurement.bidEvaluation.path}/${e.target.id}`);

  const search = (value) => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setfilterTable(filterTable);
  };
  const setfilterTableNull = (e) => {
    if (!e.target.value) setfilterTable(null);
  };

  const showTotal = (total) => `Total: ${total}`;
  const openAddModal = () => {
    handleOpenAddModal(true);
  };
  const exportRecords = () => {
    message.loading("Processing document for export please wait ", 3);
    handleExportRecords();
  };
  const generateRecordsPdf = () => {
    const pdfColumns = ["Bid Evaluation Form No.", "RFQ No."];
    let pdfRows = [];
    data?.forEach((record) => {
      const row = [record.id, record.rfqno];
      pdfRows.push(row);
    });
    generatePDF(
      pdfRows,
      pdfColumns,
      `Amani Initiative Bid Evaluation Forms - ${new Date().toLocaleDateString()}`,
      "Amani Initiative Bid Evaluation Forms.pdf"
    );
  };
  /* Use effect */
  useEffect(() => {
    if (logDetailsSuccess && records === "bidEvaluations") {
      message.info("Started download");
      generateRecordsPdf();
    } else if (!logDetailsSuccess && logDetailsError)
      message.error(logDetailsError);
    if (deleteSuccess && deleteMessage) message.success(deleteMessage);
    else if (!deleteSuccess && deleteError) message.error(deleteError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    logDetailsSuccess,
    logDetailsError,
    deleteSuccess,
    deleteMessage,
    deleteError,
  ]);

  return (
    <div>
      <Table
        pagination={{ total: data.length, showSizeChanger: true, showTotal }}
        loading={loading}
        title={() =>
          TableTitle({
            search,
            setfilterTableNull,
            refreshTable,
            exportRecords,
            openAddModal,
          })
        }
        bordered={true}
        dataSource={filterTable === null ? data : filterTable}
        columns={columns}
      />
    </div>
  );
};

export default BidEvaluationsTable;
